import axiosInstance from "./service-instance";

const getBusinessProductList = (search) => 
    axiosInstance.get("/business-product/list/", {
        params: {
            search
        }
    });

const searchBusinessProgram = (search) =>
    axiosInstance.get("/business-program/list/", {
        params: {
            search
        }
    });

const getBrandProductLines = (search) =>
    axiosInstance.get("brand-product/line/", {
        params: {
            search
        }
    });
const createBusinessProgram = (data) =>
    axiosInstance.post("/business-program/create/", data);

const updateBusinessProgram = (business_program_id, data) =>
    axiosInstance.put(`/business-program/${business_program_id}/update/`, data);

const getBusinessProgram = (business_program_id) =>
    axiosInstance.get(`/business-program/${business_program_id}/`);

const getCompanyBusinessProgram = (company_id) => 
    axiosInstance.get(`/business-program/${company_id}/company/`);

const createBasicDetails = (data) =>
    axiosInstance.post("/business-program/basic-details/create/", data);

const updateBasicDetails = (business_program_id, data) =>
    axiosInstance.put(`/business-program/basic-details/${business_program_id}/update/`, data);

const createBuyerQualificationDetails = (data) =>
    axiosInstance.post("/business-program/buyer-qualification-details/create/", data);

const updateBuyerQualificationDetails = (business_program_id, data) =>
    axiosInstance.put(`/business-program/buyer-qualification-details/${business_program_id}/update/`, data);

const createBusinessProgramCashBack = (data) =>
    axiosInstance.post("/business-program/cashback/create/", data);

const updateBusinessProgramCashBack = (business_program_id, data) =>
    axiosInstance.put(`/business-program/cashback/${business_program_id}/update/`, data);

const createBusinessProgramFacilityDetails = (data, business_program_id) =>
    axiosInstance.post(`/business-program/${business_program_id}/facility-details/`, data);

const createBusinessProgramFacilityProductLine = (data) =>
    axiosInstance.post("/business-program/facility-product-line/create/", data);

const createBusinessProgramFee = (data, business_program_id) =>
    axiosInstance.post(`/business-program/${business_program_id}/fee/`, data);

const createBusinessProgramInterest = (data, business_program_id) =>
    axiosInstance.post(`/business-program/${business_program_id}/interest/`, data);

const createBusinessProgramRecourseDetails = (data) =>
    axiosInstance.post("/business-program/recourse-details/create/", data);

const updateBusinessProgramRecourseDetails = (business_program_id, data) =>
    axiosInstance.put(`/business-program/recourse-details/${business_program_id}/update/`, data);

const createBusinessAgreementDetails = (data) =>
    axiosInstance.post("/business-program/agreement-details/create/", data);

const updateBusinessAgreementDetails = (business_program_id, data) =>
    axiosInstance.put(`business-program/agreement-details/${business_program_id}/update/`, data);

const createBusinessAttachments = (data) =>
    axiosInstance.post("/business-program/attachments/create/", data, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });

const updateBusinessAttachementDetails = (business_program_id, data) =>
    axiosInstance.patch(`business-program/attachments/${business_program_id}/update/`, data, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });

const getBusinessProgramList = () =>
    axiosInstance.get("business-program/list/");

const entityLookup = (str, config) =>
    axiosInstance.get("/company/list/", {
        headers: {
            "Content-Type": "application/json"
        },
        params: {
            name: str,
            ...config
        }
    });

const deleteFacilityDetails = (id) =>
    axiosInstance.post(`/business-program/${id}/inactive/facility-details/`);
const deleteFeeDetails = (id) =>
    axiosInstance.post(`/business-program/${id}/inactive/fee/`);
const deleteInterestDetails = (id) =>
    axiosInstance.post(`/business-program/${id}/inactive/interest/`);

export default {
    getBusinessProductList,
    createBusinessProgram,
    getBusinessProgram,
    createBuyerQualificationDetails,
    createBusinessProgramCashBack,
    createBusinessProgramFacilityDetails,
    createBusinessProgramFacilityProductLine,
    createBusinessProgramInterest,
    createBusinessProgramFee,
    createBusinessProgramRecourseDetails,
    getBusinessProgramList,
    getBrandProductLines,
    entityLookup,
    searchBusinessProgram,
    updateBusinessProgram,
    updateBuyerQualificationDetails,
    updateBusinessProgramRecourseDetails,
    createBusinessAgreementDetails,
    updateBusinessAgreementDetails,
    createBusinessAttachments,
    updateBusinessAttachementDetails,
    updateBusinessProgramCashBack,
    createBasicDetails,
    updateBasicDetails,
    deleteFacilityDetails,
    deleteFeeDetails,
    getCompanyBusinessProgram,
    deleteInterestDetails
};